module.exports = __webpack_public_path__ + "img/stat-icon-4.2f1e858c.png";